import { useEffect, useState, useRef} from 'react';
import axios from 'axios';
import {getAbbrState} from './helpers/helpers.js';



if (typeof window.kw_from_search === 'undefined') window.kw_from_search = "";
if (typeof window.predefined_kw === 'undefined') window.predefined_kw = "";
if (typeof window.predefined_cats === 'undefined') window.predefined_cats = [];
if (typeof window.predefined_job_types === 'undefined') window.predefined_job_types = [];
if (typeof window.predefined_state === 'undefined') window.predefined_state = "";
if (typeof window.predefined_city === 'undefined') window.predefined_city = "";

//let source = axios.CancelToken.source();

/* Job Search modal 10/9/2024 */
if (typeof window.cats_from_search === 'undefined') window.cats_from_search = [];
if (typeof window.location_from_search === 'undefined') window.location_from_search = [];
/*
if (typeof window.states_from_search === 'undefined') window.states_from_search = [];
if (typeof window.cities_from_search === 'undefined') window.cities_from_search = [];
*/


window.params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});

if (window.params.kw) window.predefined_kw = window.params.kw;
if (window.params.city) window.predefined_city =window.params.city;
if (window.params.state) window.predefined_state = window.params.state.toUpperCase();
if (window.params.category)  window.predefined_cats = window.params.category.split(" "); //In URL, param space comes as a plus




console.log("KEYWORD: " + window.predefined_kw);

const useFetchData = (jobParams={}) => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        //source = axios.CancelToken.source();
        const source = axios.CancelToken.source() // <-- 1st step
        let keywords = jobParams.hasOwnProperty('keywords') ? jobParams['keywords'] : window.kw_from_search;
        const categories = jobParams.hasOwnProperty('categories') ? jobParams['categories'] : null;
        const job_types = jobParams.hasOwnProperty('types') ? jobParams['types'] : null;
        const states = jobParams.hasOwnProperty('states') ? jobParams['states'] : null;
        const cities = jobParams.hasOwnProperty('cities') ? jobParams['cities'] : null;
        const sort_id = jobParams.hasOwnProperty('sort_id') ? jobParams['sort_id'] : null
        const sort_id_qs = sort_id !== null && `sort_id=${sort_id}`;
        const search_after_count = jobParams.hasOwnProperty('search_after_count') ?  jobParams['search_after_count'] : null
        const search_after_count_qs = search_after_count !== null && `search_after_count=${search_after_count}`;
        const from = jobParams.hasOwnProperty('from') ? jobParams['from'] : 0;
        const qs_params = [sort_id_qs, search_after_count_qs].filter(Boolean).join('&');
        let sort = [{"modified_at.date": "desc"}]
        
        keywords = (keywords !== null && keywords !== "") ? keywords : window.predefined_kw;
        

        //console.log("qs_params: " + qs_params)

        const queryParams = (keywords, filters) => {
            let query = {"bool" : {}},
                facet_filter = [{"bool" : {
                    "must" : [{"term": {"job_board_url.enum": "http://www.soliant.com"}}]
                }}],
                should = []


            if (keywords !== null && keywords !== "") {
                keywords = keywords.replace(/\bor\b/gi, "operating room"); //fixes OR, OR Nurse, OR-RN etc since elastic reserves OR for operators
                const re = /\S+@\S+\.\S+/; //email 
                //if email match just look at the email and mofify sort. 
                let field_to_use = (re.test(keywords)) ? ["org_unit_email"] : ["job_title^3", "job_city^2", "job_description_raw", "job_category", "job_type"];
                let sort_to_use = (re.test(keywords)) ? [{ "modified_at.date":   { "order": "desc",  "format": "strict_date_optional_time_nanos" }}] : [{ "_score": { "order": "desc" }},{ "modified_at.date":   { "order": "desc",  "format": "strict_date_optional_time_nanos" }}];

                query["bool"] = {
                    "must" : [{
                        "multi_match" : {
                            "query" : keywords.trim(),
                            "fields" : field_to_use,
                            operator: "and"
                        }
                    }]
                }

                sort = sort_to_use
                
                ///if (window.kw_from_search) Object.assign(query["bool"]["must"]["multi_match"], {operator: "and"});
                
            }            
            
            if (states !== null && states.length > 0) {
                facet_filter[0]["bool"]["must"].push({"terms": {"job_state_abbr.enum": states}})
            }
            else if (window.predefined_state !== "") {
                facet_filter[0]["bool"]["must"].push({"terms": {"job_state_abbr.enum": [getAbbrState(window.predefined_state)]}})
            }

            if (cities !== null && cities.length > 0) {
                facet_filter.push({"terms": {"job_city.enum": cities}})
            }
            else if (window.predefined_city !== "") {
                facet_filter.push({"terms": {"job_city.enum": [window.predefined_city.replaceAll("_", " ")]}})
            }
           
            if (categories !== null && categories.length > 0) {
                facet_filter.push({"terms": {"job_category.enum": categories}})
            }
            else if (window.predefined_cats.length>0) {
                //use predefined cats
                window.predefined_cats = (typeof(window.predefined_cats) === "string") ? JSON.parse(window.predefined_cats) : window.predefined_cats;

                facet_filter[0]["bool"]["must"].push({"terms": {"job_category_id.float": window.predefined_cats}})
            }

            /* Job Search modal 10/9/2024 */
            if (window.cats_from_search.length>0) {
                window.cats_from_search = (typeof(window.cats_from_search) === "string") ? JSON.parse(window.cats_from_search) : window.cats_from_search;
                facet_filter[0]["bool"]["must"].push({"terms": {"job_category.enum": window.cats_from_search}})
            }

            /* job search modal 10/14 */
            if (window.location_from_search.length>0) {
                window.location_from_search.forEach(location => {
                    
                    //check if city, state
                    if (location.includes(",")) {
                        let [city, state] = location.split(",");

                        should.push({
                            "bool" : {
                                "must" : [
                                    {"match": {"job_city.enum": city.trim()}}, 
                                    {"match": {"job_state_abbr.enum": getAbbrState(state.trim())}}
                                ]
                            }
                        }) 
                    }
                    else {
                        should.push({
                            "bool" : {
                                "must" : [
                                    {"multi_match" : {"query" : location.trim(), "fields" :["job_state^3", "job_city^2"], operator: "AND"}}
                                ]
                            }
                        }) 
                    }    
                });
            }        

            if (job_types !== null && job_types.length > 0) {
                facet_filter.push({"terms": {"job_type.enum": job_types}})
            }
            else if (window.predefined_job_types.length>0) {
                //use predefined cats
                facet_filter[0]["bool"]["must"].push({"terms": {"job_type_id.float": JSON.parse(window.predefined_job_types)}})
            }

            //facet_filter[0]["bool"]["must"].push({"range": {"modified_at.date": {"gte": "now-31d/d", "lt": "now/d"}}}) //only pull the last 30 days
            facet_filter[0]["bool"]["must"].push({"range": {"modified_at.date": {"gte": "now-61d/d"}}}) //only pull the last 30 days
            
            
            //console.log("THE FACETS: " + JSON.stringify(facet_filter));

            query["bool"]["filter"] = facet_filter;

            if (should.length>0) {
                query["bool"]["should"] = should;
                query["bool"]["minimum_should_match"] = 1
            }


           // console.log("THE QUERY: " + JSON.stringify(query));
            return query;
        }

        const compiledData = {
            "from": from,
            "size": 1000,
            "query": queryParams(keywords),
            "aggs": {
                "job_count": {
                        "value_count" : { "field" : "job_board_url.enum" } 
                },
                "categorieslist": {
                    "terms": { 
                        "field": "job_category.enum",
                        "size": 200,
                        "order": {"_key" : "asc"}
                        }  
                },
                "typelist": {
                    "terms": { 
                        "field": "job_type.enum",
                        "size": 10,
                        "order": {"_key" : "asc"}
                        }  
                },
                "stateslist": {
                        "terms": { 
                            "field": "job_state_abbr.enum",
                            "size": 51,
                            "order": {"_key" : "asc"}
                        },
                        "aggs": {
                            "city-list": {
                            "terms": {
                                "field": "job_city.enum",
                                /*"size": 200,*/
                                "size": 15000,
                                "order": {"_key" : "asc"}
                            }
                        }
                    }
                }
            },
            "fields": [
                "job_order_id",
                "job_title",
                "job_category_main",
                "job_category",
                "job_category_id",
                "job_type",
                "job_city",
                "job_state_abbr",
                "job_postal",
                "job_description_raw",
                "modified_at"
            ],
            "sort": sort,      
            "_source": false  
        }
        

//        console.log("compiledJSONData: " + JSON.stringify(compiledData));
        //console.log("sort_id: " + sort_id);
        

        const fetchData = async (compiledData, qs_params) => {
           
        
            try {
                //if (ref) {cancelAllCalls(); console.log("ABORT")};
                // https://proxy.sunbeltstaffingjobs.com:4143/post_job_search.php?
                // /wp-content/themes/sunbelt/classes/post_job_search.php?
                
                setLoading(true);
                const { data: response } = await axios({
                    method: 'post',
                    url: 'https://proxy.sunbeltstaffingjobs.com:4143/post_job_search.php?' + qs_params,
                    cancelToken: source.token,
                    headers: {
                        'Content-Type' : 'application/json',
                        'Accept': 'Token',
                        "Access-Control-Allow-Origin": "*",
                    },
                    data: JSON.stringify(compiledData)
                });
                setData(response);
                //console.log("the response: " +  response);
            } 
            catch (error) {
                console.error("there was an error: " + error)
            }
            finally {
                setLoading(false);
                //if (source) source.cancel("Landing Component got unmounted");
            }
            
            

        };

        fetchData(compiledData, qs_params);

        return () => {
            if (source) source.cancel() // <-- 3rd step
          }
    }, [jobParams]);

    return {data, loading};
};

export default useFetchData;